export default __webpack_public_path__ + "static/bahn4-15c1b58ee842a4298b1628180839983c.gif";